import { useAppSelector } from '~/redux/hooks'

import { Breakpoint, useScreenBreakPoints } from '~/utils'

import { selectGradeListByCountry } from '../slice/curriculum.slice'

import { GradeDesign } from './GradeDesign'

export default function NorwegianAboveTenGradeList(): React.ReactElement {
  const gradeList = useAppSelector(selectGradeListByCountry)
  // eslint-disable-next-line fp/no-mutating-methods
  const sortedGradeList = gradeList.slice(10).sort((a, b) => (a.gradeLevel < b.gradeLevel ? -1 : 1))
  const isDesktop = useScreenBreakPoints({ gt: Breakpoint.LG })
  const isSmallerThanDesktop = useScreenBreakPoints({ lt: Breakpoint.LG })

  return (
    <div className="flex flex-col items-center justify-center xl:p-0 space-y-6 mt-8 w-full sm360:w-auto">
      {isDesktop && (
        <>
          <div className="grid grid-cols-1 md:grid-cols-2 gap-5 md:gap-7">
            {sortedGradeList.slice(0, 2).map((grade) => (
              <GradeDesign grade={grade} key={grade._id} />
            ))}
          </div>
          <div className="grid grid-cols-3 gap-5 md:gap-7">
            {sortedGradeList.slice(2, 5).map((grade) => (
              <GradeDesign grade={grade} key={grade._id} />
            ))}
          </div>
          <div className="grid grid-cols-2 gap-5 md:gap-7">
            {sortedGradeList.slice(5, 7).map((grade) => (
              <GradeDesign grade={grade} key={grade._id} />
            ))}
          </div>
        </>
      )}
      {isSmallerThanDesktop && (
        <>
          <div className="grid grid-cols-1 md:grid-cols-2 gap-5 md:gap-7 w-full sm360:w-auto">
            {sortedGradeList && sortedGradeList.map((grade) => <GradeDesign grade={grade} key={grade._id} />)}
          </div>
        </>
      )}
    </div>
  )
}
